import React, { PropsWithChildren, useRef } from "react";

import { Map } from "leaflet";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { MapContainer, TileLayer } from "react-leaflet";

const MapWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const mapRef = useRef<Map | null>(null);
  return (
    <div className="relative">
      <MapContainer
        id="map"
        scrollWheelZoom
        doubleClickZoom={false}
        zoomControl={false}
        ref={mapRef}
        maxZoom={18}
        minZoom={7}
        className="mt-2"
        style={{ height: "69vh" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {children}
      </MapContainer>
    </div>
  );
};

export default MapWrapper;
